/**
 * axios请求头枚举
 * */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8'
}

/**
 * 接口返回code字段，代表不同返回类型
 * */
export enum ResponseCodeEnum {
  SUCCESS = 200, // 操作成功
  BUSINESS_ERROR = 600, // 业务异常
  SERVER_ERROR = 500 // 服务器异常
}

export enum ResponseStatusEnum {
  SUCCESS = 200, // 操作成功
  SERVER_ERROR = 500, // 服务器报错
  UNAUTHORIZED = 401, // 登录凭证过期
  FORBIDDEN = 403, // 未授权的操作
  NO_FUND = 404, // 404
  NO_LOGIN = 406 // 406 时段限制登录
}
// 错误消息映射表
export const errorMessageMap: Record<string, { code: ResponseStatusEnum; message: string }> = {
  [ResponseStatusEnum.SERVER_ERROR]: {
    code: ResponseStatusEnum.SERVER_ERROR,
    message: '服务不可用，请联系管理员!'
  },
  [ResponseStatusEnum.UNAUTHORIZED]: {
    code: ResponseStatusEnum.UNAUTHORIZED,
    message: '登录凭证已过期，请重新登录！'
  },
  [ResponseStatusEnum.FORBIDDEN]: {
    code: ResponseStatusEnum.FORBIDDEN,
    message: '暂未授权此操作，请联系管理员授权！'
  },
  [ResponseStatusEnum.NO_LOGIN]: {
    code: ResponseStatusEnum.NO_LOGIN,
    message: '登录时段受限！' // 这里使用相同的默认消息，可以根据实际情况调整
  }
}
